<template>
  <el-dialog title="打印" :visible.sync="dialogPrintVisible" append-to-body @closed="closePrint" v-if="visiblePrint">
    <div id="printAll">
      <div class="header-info">
        <div class="company-name">
          {{ exportFrom.companyName }}
          <br />
          <span>生产计划单</span>
          <img :src="exportFrom.qrUrl" alt="" class="qrCode" />
        </div>

        <div class="flex">
          <div class="order-code">计划单号: {{ exportFrom.orderNo }}</div>
          <div class="order-code">计划人员: {{ exportFrom.planPerson }}</div>
        </div>
        <div class="flex">
          <div class="order-code">合同号: {{ exportFrom.htNo }}</div>
          <div class="plan-date">计划单日期: {{ exportFrom.planDate }}</div>
        </div>
        <div class="flex">
          <div class="plan-date">预计完工: {{ exportFrom.deliveryTime }}</div>
          <div class="customer-code">客户代号: {{ exportFrom.customerNo }}</div>
        </div>
        <div class="flex">
          <div class="customer-code">溢装: {{ exportFrom.yiz }}</div>
         
          <div class="customer-codemgl10 status-info">
            出库状态：
            <span v-if="exportFrom.status == 0" type="danger">未出库</span>
            <span v-else-if="exportFrom.status == 1" type="success">部分出库</span>
            <span v-else-if="exportFrom.status == 2" type="warning">已出库</span>
          </div>
          <div class="customer-code auto"></div>
        </div>
        <div class=""></div>
      </div>

      <!-- 表格内容 -->
      <table class="print-table">
        <thead>
          <tr>
            <th>型号</th>
            <th>产品名称</th>
            <th>工艺号</th>
            <th>规格</th>
            <th>数量</th>
            <th>面积/重量</th>
            <th>实际出库数量</th>
            <th class="order-remarks-header">订单备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in exportFrom.tableData" :key="index">
            <td>{{ item.modelNo }}</td>
            <td>{{ item.className }}</td>
            <td>{{ item.gyNo }}</td>
            <td>{{ item.specCode }}</td>
            <td>{{ item.num }}</td>
            <td>{{ item.weight }}</td>
            <td>{{ item.outNum }}</td>
            <td>{{ item.remarks }}</td>
          </tr>
          <tr>
            <td colspan="4">总计:</td>
            <td colspan="4">{{ totalQuantity }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="footer" class="footer">
      <el-button @click="dialogPrintVisible = false">取 消</el-button>
      <el-button type="primary" @click="printbatch">打 印</el-button>
      
    </div>
  </el-dialog>
</template>

<script>
  import { selectAllPrintList, exportList } from "@/api/storeCodePrint.js";
  import { fetchWarehouseList } from "@/api/storeWarehouse.js";
  import print from "vue-print-nb";
  import { codeUrl } from "@/utils/constant";
  import { baseUrl } from "@/utils/index";

  export default {
    directives: { print },
    data() {
      return {
        codeUrl: codeUrl,
        userInfo: "",
        exportFrom: {
          companyName: "",
          planPerson: "",
          htNo: "",
          yiz: "",
          orderNo: "",
          planNumber: "",
          planDate: "",
          customerNo: "",
          deliveryTime: "",
          tableData: [
            {
              modelNo: "",
              className: "",
              className: "",
              specCode: "",
              num: "",
              weight: "",
              remarks: "",
            },
          ],
          qrUrl: "",
        },
        dialogPrintVisible: false,
        printId: "",
        printList: [],
        paperWidth: 70,
        paperHeight: 30,

        visiblePrint: false,
        marginsWidth: 6,
        marginsHeight: 4,
      };
    },
    // components: { VueQr },
    props: {},
    computed: {
      totalQuantity() {
        return this.exportFrom.tableData.reduce(
          (total, item) => total + parseInt(item.num, 10),
          0
        );
      },
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem("info"));
      this.userInfo = userInfo;
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName;
      }
    },
    mounted() {
      this.getAllPrint();
    },
    methods: {
      init(id) {
        this.getPrintData(id);
      },
      choosePrint() {
        let fe = this.printList.filter((item) => {
          return item.id == this.printId;
        });
        if (fe) {
          this.paperWidth = fe[0].paperWidth;
          this.paperHeight = fe[0].paperHeight;
        }
        // this.initSize()
      },
      getAllPrint() {
        selectAllPrintList().then((res) => {
          this.printList = res.data;
          if (this.printList && this.printList.length > 0) {
            this.printId = this.printList[0].id;
            this.choosePrint();
          }
        });
      },
      getPrintData(id) {
        exportList({ oderId: id }).then((res) => {
          this.exportFrom = res.data[0];
          this.exportFrom.tableData = res.data[0].details;
          this.exportFrom.qrUrl = baseUrl + res.data[0].imgUrl;
          console.log(this.exportFrom, "XXX");
          this.dialogPrintVisible = true;
        });
      },
      printbatch() {
        const printStyle = `<style>@media print{body{margin: 0px; padding: 0;}}</style>`;
        const cssStyle = `<style>.header-info {
    text-align: center;
    margin-bottom: 20px;
  }

  .company-name,
  .order-code,
  .plan-number,
  .plan-date,
  .customer-code {
    margin: 5px 0;
  }

  .print-table {
    width: 100%;
    border-collapse: collapse;
  }

  .print-table th,
  .print-table td {
    border: 1px solid black;
    padding: 8px;
    text-align: center;
  }

  .print-table th {
    background-color: #f2f2f2;
  }

  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .company-name {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 20px;
    position: relative;
  }

  .qrCode {
    width: 120px;
    height: 120px;
    position: absolute;
    top: 65px;
    right: 0px;
  }

  .order-code,
  .plan-date,
  .customer-code {
    width: 220px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .order-remarks-header {
    width: 150px;
  }
    </style>`;

        // 隐藏不需要打印的元素
        const areaWeightHeader = document.querySelector(
          ".print-table thead tr th:nth-child(6)"
        );
        const outNumHeader = document.querySelector(
          ".print-table thead tr th:nth-child(7)"
        );
        const areaWeightCells = document.querySelectorAll(
          ".print-table tbody tr td:nth-child(6)"
        );
        const outNumCells = document.querySelectorAll(
          ".print-table tbody tr td:nth-child(7)"
        );
        const totalRow = document.querySelector(
          ".print-table tbody tr:last-child"
        );
        const statusInfo = document.querySelector(".status-info"); // 选择状态部分
        areaWeightHeader.style.display = "none";
        outNumHeader.style.display = "none";
        areaWeightCells.forEach((cell) => (cell.style.display = "none"));
        outNumCells.forEach((cell) => (cell.style.display = "none"));
        totalRow.style.display = "none";
        statusInfo.style.display = "none"; // 隐藏状态部分

        var newWin = window.open("");
        var rowToPrint = document.getElementById("printAll");
        newWin.document.write(rowToPrint.outerHTML);

        newWin.document.head.innerHTML = printStyle;
        newWin.document.head.innerHTML = cssStyle;
        newWin.document.close();
        newWin.focus();
        setTimeout(function () {
          newWin.print();
          newWin.close();

          // 恢复元素显示
          if (areaWeightHeader) areaWeightHeader.style.display = "";
          if (outNumHeader) outNumHeader.style.display = "";
          areaWeightCells.forEach((cell) => (cell.style.display = ""));
          outNumCells.forEach((cell) => (cell.style.display = ""));
          if (totalRow) totalRow.style.display = "";
          if (statusInfo) statusInfo.style.display = ""; // 恢复状态部分显示
        }, 100);
      },
      closePrint() {
        this.visiblePrint = false;
      },
    
    },
  };
</script>

<style>
  .header-info {
    text-align: center;
    margin-bottom: 20px;
  }

  .company-name,
  .order-code,
  .plan-number,
  .plan-date,
  .customer-code {
    margin: 5px 0;
  }

  .print-table {
    width: 100%;
    border-collapse: collapse;
  }

  .print-table th,
  .print-table td {
    border: 1px solid black;
    padding: 8px;
    text-align: center;
  }

  .print-table th {
    background-color: #f2f2f2;
  }

  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .company-name {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 20px;
    position: relative;
  }

  .qrCode {
    width: 120px;
    height: 120px;
    position: absolute;
    top: 65px;
    right: 0;
  }

  .order-code,
  .plan-date,
  .customer-code {
    width: 300px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .auto {
    margin-right: auto;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
  }

  .el-dialog__body {
    padding-top: 0 !important;
  }

  .order-remarks-header {
    width: 150px;
  }
</style>